/* AUTAVEX — екошкіра: додаток — прибирає третій ряд там, де його немає в базі */
(function(){
function Q(i){return document.getElementById(i)}
function car(){
  /* беремо обране авто з плашки конструктора */
  var d=document.querySelector('#ekCar .done .t');
  if(!d)return null;
  var full=(d.querySelector('b')||{}).textContent||'';
  var rest=((d.querySelector('span')||{}).textContent||'').split('\u00b7');
  var parts=full.trim().split(' ');
  return {brand:parts.shift(),model:parts.join(' '),
          year:parseInt((rest[0]||'').trim(),10),body:(rest[1]||'').trim()};
}
function has(){
  var DB=window.AV_DB,c=car();
  if(!DB||!DB.brands||!c||!c.brand)return true;   /* невідомо — не чіпаємо */
  var rows=DB.brands[c.brand]||[];
  for(var i=0;i<rows.length;i++){
    var r=rows[i];
    if(r[0]===c.model&&r[1]===c.body&&c.year>=r[2]&&c.year<=r[3])return !!r[6];
  }
  return true;
}
function hide(){
  if(!Q('ek'))return;
  if(has())return;
  /* знайти рядок «Третій ряд» у блоку Додати до комплекту */
  var opts=document.querySelectorAll('#ekBody .opt[data-opt="row3"]');
  for(var i=0;i<opts.length;i++){
    if(opts[i].classList.contains('on'))opts[i].click();   /* зняти вибір */
    opts[i].style.display='none';
  }
  /* і рядок у розрахунку */
  var calc=Q('ekBody')?Q('ekBody').querySelector('.calc'):null;
  if(calc){
    var rows=calc.querySelectorAll('div');
    for(var j=0;j<rows.length;j++){
      var t=(rows[j].firstChild&&rows[j].firstChild.textContent)||'';
      if(t.indexOf('\u0422\u0440\u0435\u0442\u0456\u0439 \u0440\u044f\u0434')===0)rows[j].style.display='none';
    }
  }
}
function run(){try{hide()}catch(e){}}
document.addEventListener('click',function(){setTimeout(run,120)},false);
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(run,900)})}
else{setTimeout(run,900)}
var n=0,t=setInterval(function(){n++;run();if(n>20)clearInterval(t)},700);
})();
